// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb6777a6","455":"898c38c2","977":"23da7537"}[chunkId] + ".chunk.js";
};